var api = "https://api.qingcigame.com/web";

var index = '';
var go_page = window.location.href.split('?page=')[1];

var initialSlide = 0; //设置默认索引为0
var num = 0; //默认播放第一首音乐
var type = 2; //接口默认语言类型为英语

const DEFAULT_LANGUAGE = "en";
let language_index = DEFAULT_LANGUAGE; //标识语言

// 多语言音乐信息
let languages = {
    zh: {
        music: [
            "《仙剑问情》",
            "《杀破狼》"
        ],
        music_content: [
            "凄婉悠长的乐声响起，一群白鹤在青天白云间展翅翱翔，烟云缥缈的仙山若隐若现……",
            "《仙剑奇侠传一电视剧》主题曲《杀破狼》：人道渺渺，仙道茫茫，鬼道乐兮！"
        ]
    },
    en: {
        music: [
            '"Sword & Romance"',
            '"Sha Po Lang"'
        ],
        music_content: [
            "As the melodious and poignant music begins, a flock of white cranes soars in the blue sky, with misty immortal mountains faintly visible...",
            'Theme Song of the TV Drama "Chinese Paladin"'
        ]
    },
    th: {
        music: [
            'กระบี่ถามใจ',
            '"Sha Po Lang"'
        ],
        music_content: [
            "เสียงเพลงเศร้าเริ่มดังก้อง ฝูงนกกระเรียนขาวโผบินในท้องฟ้าสีฟ้า เมฆหมอกบนภูเขาเซียนปรากฏแล้วก็หายไป...",
            'เพลงประกอบละคร "เซียนกระบี่พิชิตมาร ภาค 1" ชื่อเพลง "Sha Po Lang" หนทางมนุษย์แคบเลือนลาง หนทางเซียนกว้างไกล หนทางปีศาจเต็มไปด้วยความสุข!'

        ]
    }
};

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                var strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                }
            }
        };
        getRequest(); //二级页面导航栏跳转
        this.preloading(); // 预加载
        this.jqslideTxtBox(); // 游戏咨询信息切换
        this.indexBind(); // 首页按钮
        this.countNum(); //阿里云埋点
        this.language(); // 多语言
        this.indexAjax(); // 首页接口请求
    },
    // 游戏攻略列表
    intrList: function() {
        this.newsIntrList(); // 攻略最新列表
        this.newsTabPage(); // 最新、综合、活动跳转
    },
    // 游戏攻略详情
    intrDetails: function() {
        this.intrInfo();
        this.scroll();
    },
    imgClick: function() {
        $('.details-info img').on('click', function() {
            var _this = $(this);
            var img_url = _this.attr('src');
            $('.wallpaper-wrap').fadeIn();
            $('.wallpaper-wrap img').attr("src", img_url);
        });

        $('.wallpaper-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            setTimeout(() => {
                $('.wallpaper-wrap img').attr("src", '');
            }, 300)
        });
    },
    // 首页按钮
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        });

        // 充值按钮
        $('.top-up-btn').click(function(event) {
            if (language_index == "zh" || language_index == "zh_CN") {
                layer.msg("敬请期待", { time: 2000 });
            } else if (language_index == "th") {
                layer.msg("โปรดติดตาม", { time: 2000 });
            } else {
                layer.msg("Please stay tuned", { time: 2000 });
            }
        });

        // 关闭弹窗
        $('.popup').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
        });

        // 游戏攻略切换
        $(".intro li").on('click', function() {
            $(this).addClass("active").siblings().removeClass("active");
        });

        // 仙剑音画【壁纸】& 攻略详情页图片预览
        $(".wallpaper-box .item img , .details-info img").on('click', function() {
            var _this = $(this);
            var img_url = _this.attr('src');
            $('.wallpaper-wrap').fadeIn();
            $('.wallpaper-wrap img').attr("src", img_url);
        });

        $('.wallpaper-wrap').on('click', '.close-btn', function(event) {
            $('.popup').fadeOut();
            setTimeout(() => {
                $('.wallpaper-wrap img').attr("src", '');
            }, 300)
        });

        $('.download-btn').on('click', function(event) {
            var className = $(this).attr('class');
            var game_id = 115;
            $.ajax({
                type: "get",
                url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    var googleUrl = json.data.android_down_url; //谷歌
                    var iosUrl = json.data.ios_down_url; //ios
                    var leidianUrl = json.data.thunder_down_url; //雷电
                    var leidianEnUrl = json.data.bbs_url; //雷电英文->对应论坛
                    var leidianThUrl = json.data.jump_url; //雷电泰文->对应跳转地址
                    var landieUrl = json.data.mumu_down_url; //蓝叠
                    var landieEnUrl = json.data.web_url; //蓝叠英文->对应web
                    var landieThUrl = json.data.blue_url; //蓝叠泰文->对应蓝叠下载地址

                    function handleDownload(url) {
                        if (!url) {
                            if (language_index == "zh" || language_index == "zh_CN") {
                                layer.msg("敬请期待", { time: 2000 });
                            } else if (language_index == "th") {
                                layer.msg("โปรดติดตาม", { time: 2000 });
                            } else {
                                layer.msg("Please stay tuned", { time: 2000 });
                            }
                        } else {
                            location.href = url;
                        }
                    };

                    // 根据按钮的类名处理对应的下载链接
                    if (className.indexOf('app-btn') !== -1) {
                        handleDownload(iosUrl);
                    } else if (className.indexOf('leidian-btn-zh') !== -1) {
                        handleDownload(leidianUrl);
                    } else if (className.indexOf('leidian-btn-en') !== -1) {
                        handleDownload(leidianEnUrl);
                    } else if (className.indexOf('leidian-btn-th') !== -1) {
                        handleDownload(leidianThUrl);
                    } else if (className.indexOf('landie-btn-zh') !== -1) {
                        handleDownload(landieUrl);
                    } else if (className.indexOf('landie-btn-en') !== -1) {
                        handleDownload(landieEnUrl);
                    } else if (className.indexOf('landie-btn-th') !== -1) {
                        handleDownload(landieThUrl);
                    } else {
                        handleDownload(googleUrl);
                    };
                }
            });
        });
    },
    // 仙剑音画
    indexMedia: function() {
        var Media = document.getElementById('media-play');
        // 媒体视频播放
        var videoBtn = document.getElementById('videoBtn');
        videoBtn.onclick = function() {
            var videoSrc = $(".right-video-box video").attr("src");
            if (videoSrc) {
                $('.thumbnail-img').fadeOut(); //视频展示图
                $('.right-video-box video').fadeIn(); //视频
                $('.video-btn-box').fadeOut(); //视频按钮
                Media.play(); //播放
            } else {
                if (language_index == "zh" || language_index == "zh_CN") {
                    layer.msg("敬请期待", { time: 2000 });
                } else if (language_index == "th") {
                    layer.msg("โปรดติดตาม", { time: 2000 });
                } else {
                    layer.msg("Please stay tuned", { time: 2000 });
                }
            }
        };

        // 视频预览
        $('.left-video-box li img').on('click', function() {
            var _this = $(this);
            var img_src = _this.attr('src');
            var video_src = _this.attr('data');

            $(this).parent().addClass("on").siblings().removeClass("on");
            $('.thumbnail-img').fadeIn();
            $('.right-video-box video').show();
            $('.video-btn-box').fadeIn();

            $('.thumbnail-img').find('img').attr('src', img_src); //图片填充
            $('.right-video-box').find('video').attr('src', video_src); //视频填充
        })

        Media.addEventListener('play', () => {
            $('.video-btn-box').fadeOut(); //播放开始 播放按钮隐藏
        })

        Media.addEventListener('ended', () => {
            $('.video-btn-box').fadeIn(); //播放结束 播放按钮显示
            $('.thumbnail-img').fadeIn();
        })

        // 仙剑音画切换
        $('.media-nav-box ul li').click(function() {
            if ($(this).attr("class") == "select") {
                return false
            }

            Media.pause();
            myMusic.pause();


            $(".media-nav-box .block").css("display", "block"); //防抖动弹窗
            let a = $(this).index() + 1
                // console.log(a)
            switch (a) {
                case 1:
                    $(".music-box").fadeIn().siblings().fadeOut();
                    break;
                case 2:
                    $(".video-box").fadeIn().siblings().fadeOut();
                    break;
                case 3:
                    $(".wallpaper-box").fadeIn().siblings().fadeOut();
                    break;
                default:
                    return false
            }

            $('.record-player').addClass('ani-pause'); //添加暂时播放样式

            setTimeout(() => {
                $(".media-nav-box .block").css("display", "none");
            }, 500)
            $(this).addClass("select").siblings().removeClass("select");
        });

        //音乐播放按钮
        var next = document.getElementById("next");
        var prev = document.getElementById("prev");
        var musicBtn = document.getElementById("musicBtn");
        const myMusic = document.getElementById("myMusic");

        // 获取元素
        const progressBar = document.getElementById('progress-bar');
        const progress = document.querySelector('.progress');
        const progressHandle = document.querySelector('.progress-handle');

        // 音乐信息
        var music = languages[language_index].music;
        var music_content = languages[language_index].music_content;
        var music_url = [
            "//download4.qcplay.com/qcgame-admin/t3L9IRtsLLoZyS06LnQ6qSyNQIgH50PzXt7xT5aF.mp3",
            "//download4.qcplay.com/qcgame-admin/Ywo1SupJovxuyF92dANET8zo9B66E1AAlKvIseWh.mp3"
        ];

        $('.music-title').html(music[num]); //音乐标题
        $('.music-content').html(music_content[num]); //音乐描述

        // 点击音乐
        function toggleMusic() {
            // console.log("music play: ", $('#myMusic')[0].paused);
            if ($('#myMusic')[0].paused) {
                $('#myMusic')[0].play();
                $('.record-player').removeClass('ani-pause'); //去除暂时播放样式
                $('.music-title').html(music[num]); //标题
                $('.music-content').html(music_content[num]); //音乐描述

                $('.record-player').addClass('music-on'); //开始播放样式
            } else {
                $('.record-player').addClass('ani-pause'); //添加暂时播放样式
                $('#myMusic')[0].pause();
            }
        };

        musicBtn.onclick = toggleMusic;

        // 上一首
        prev.onclick = function() {
            // num = (num + 2) % music.length;
            num = (num + 3) % music.length;
            myMusic.src = music_url[num];
            $('.music-title').html(music[num]);
            $('.music-content').html(music_content[num]); //音乐描述

            myMusic.play();
            $('.record-player').removeClass('ani-pause');
            $('.record-player').hasClass('.music-on') ? '' : $('.record-player').addClass('music-on');

        };
        // 下一首
        next.onclick = function() {
            num = (num + 1) % music.length;
            myMusic.src = music_url[num];
            myMusic.play();
            $('.music-title').html(music[num]);
            $('.music-content').html(music_content[num]); //音乐描述

            $('.record-player').removeClass('ani-pause');
            $('.record-player').hasClass('.music-on') ? '' : $('.record-player').addClass('music-on');
        };

        //自动播放下一首
        myMusic.addEventListener('ended', function() {
            next.onclick();
        }, false);

        let timer = setInterval(() => {
            let str = _.convertSec2Str(myMusic.currentTime) + "/" + _.convertSec2Str(myMusic.duration);
            $('.time').html(str);
        }, 500);

        let _ = {
            repairZero(num) {
                num = num.toString()
                return num[1] ? num : ('0' + num);
            },
            makeStr() {
                let code = Array.prototype.shift.call(arguments);
                return Array.prototype.join.call(arguments, code);
            },
            convertSec2Str(total) {
                let min = _.repairZero(Math.floor(total / 60));
                let sec = _.repairZero(Math.floor(total % 60));
                return _.makeStr(':', min, sec);
            }
        };

        // 【仙剑音画】音乐进度条拖拽
        // 监听音频播放进度
        myMusic.addEventListener('timeupdate', () => {
            const progressPercent = (myMusic.currentTime / myMusic.duration) * 100;
            progress.style.width = `${progressPercent}%`;
            progressHandle.style.left = `${progressPercent}%`;
        });

        // 监听进度条点击事件
        progressBar.addEventListener('click', (event) => {
            const clickPosition = event.clientX - progressBar.getBoundingClientRect().left;
            const progressPercent = (clickPosition / progressBar.offsetWidth) * 100;
            myMusic.currentTime = (myMusic.duration / 100) * progressPercent;
        });

        // 监听进度条拖动事件
        // pc
        function pc_music_slide() {
            let isDragging = false;
            document.querySelector('.progress-handle').addEventListener('mousedown', () => {
                isDragging = true;
            });
            document.addEventListener('mousemove', (event) => {
                if (isDragging) {
                    const dragPosition = event.clientX - progressBar.getBoundingClientRect().left;
                    const progressPercent = (dragPosition / progressBar.offsetWidth) * 100;
                    myMusic.currentTime = (myMusic.duration / 100) * progressPercent;
                }
            });
            document.addEventListener('mouseup', () => {
                isDragging = false;
            });
        }

        // pad
        function pad_music_slide() {
            let isDragging = false;
            document.querySelector('.progress-handle').addEventListener('touchstart', () => {
                isDragging = true;
            });
            document.addEventListener('touchmove', (event) => {
                if (isDragging) {
                    const dragPosition = event.touches[0].clientX - progressBar.getBoundingClientRect().left;
                    const progressPercent = (dragPosition / progressBar.offsetWidth) * 100;
                    myMusic.currentTime = (myMusic.duration / 100) * progressPercent;
                }
            });
            document.addEventListener('touchend', () => {
                isDragging = false;
            });
        }

        // 【仙剑音画】壁纸进度条拖拽
        var slider = document.getElementById('drag-box');
        var block = document.getElementById('drag-bar');
        var box = document.getElementById('pics-box');
        var content = document.getElementById('pics-content');

        // pc
        function pc_wall_slide() {
            // 鼠标按下时
            block.onmousedown = function(ev) {
                // console.log('down');
                var myEvent = ev || event;

                var disX = myEvent.clientX - block.offsetLeft;

                // 鼠标移动时
                document.onmousemove = function(ev) {
                    var myEvent = ev || event;
                    var left = myEvent.clientX - disX;

                    // console.log(left);

                    setLeft(left);
                };
                // 鼠标抬起时
                document.onmouseup = function() {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            };
        }

        // pad
        function pad_wall_slide() {
            // 鼠标按下时
            block.ontouchstart = function(ev) {
                var myEvent = ev || event;
                var disX = myEvent.touches[0].clientX - block.offsetLeft;

                // 鼠标移动时
                document.ontouchmove = function(ev) {
                    var myEvent = ev || event;
                    var left = myEvent.touches[0].clientX - disX;
                    setLeft(left);
                };
                // 鼠标抬起时
                document.ontouchend = function() {
                    document.ontouchmove = null;
                    document.ontouchend = null;
                };
            };
        }

        // 设置滑块的left值
        function setLeft(left) {
            // 限制范围
            if (left < 0) {
                left = 0;
            } else if (left > slider.offsetWidth - block.offsetWidth) {
                left = slider.offsetWidth - block.offsetWidth;
            };

            block.style.left = left + 'px';

            // 计算滚动距离相对滚动范围的比例
            var scale = left / (slider.offsetWidth - block.offsetWidth);
            // 让content随着滚动的距离上下滑动显示内容
            content.style.left = -(content.offsetWidth - box.offsetWidth) * scale + 'px';
        }

        var ua = navigator.userAgent;
        var isAndroid = /(?:Android)/.test(ua);
        var isFireFox = /(?:Firefox)/.test(ua);
        var isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));

        if (isTablet) {
            // 是平板的话 用touch拖拽
            pad_wall_slide();
            pad_music_slide();
            // 取消no-swiper
            $('.music-box').removeClass('swiper-no-swiping');
            $('.video-box').removeClass('swiper-no-swiping');
            $('.wallpaper-box').removeClass('swiper-no-swiping');
        } else {
            // PC 用mouse拖拽
            pc_wall_slide();
            pc_music_slide();
        }
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loading_time p").html(parseInt(e.progress * 100) + '%');
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            var _this = this;
            $('.loading_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            this.indexSwiper();

            if (go_page == undefined) {}

            setTimeout(function() {
                $('.preloading').remove();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/official/images/pc/en/logo_icon-d8abb52015.png',
            '/official/images/pc/en/apple_btn-e22ebd1170.png',
            '/official/images/pc/en/and_btn-f52b99e7c5.png',
            '/official/images/pc/en/leidian_btn-c66ace46c7.png',
            '/official/images/pc/en/landie_btn-dad3dadde0.png',
            '/official/images/pc/en/top_up_btn-9168f34b5d.png',
            '/official/images/pc/banner_bg-ce83d0c2cd.png',
            '/official/images/pc/fb_btn-aef03f95ca.png',
            '/official/images/pc/discord_btn-6fd549282f.png',
            '/official/images/pc/fb_group_btn-9595df0cfc.png',
            '/official/images/pc/en/arrow_btn-91dcf00337.png',
            '/official/images/pc/float_nav_on_bg-ff57593b31.png',
            '/official/images/pc/float_nav_dot-51062e9a5f.png'
        ]);
    },
    // 首页接口请求
    indexAjax: function() {
        // console.log("language: ", language_index);
        // var index = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;

        type = language_index == "zh" || language_index == "zh_CN" ? 1 : language_index == "th" ? 3 : 2;

        $.ajax({
            url: api + "/sea/sword/index",
            type: "GET",
            data: {
                type: type
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var zuixin = json.data.articleList.zuixin; //最新
                    var mengxin = json.data.articleList.mengxin; //萌新
                    var jinjie = json.data.articleList.jinjie; //进阶
                    var video = json.data.articleList.video; //视频

                    var discordUrl = "https://discord.gg/BJZ4SPXMsv";

                    // url地址
                    $('.discord-btn').attr('href', discordUrl);

                    // 先清空内容
                    $('.slideTxtBox-02 .new ul').empty();
                    $('.slideTxtBox-02 .mengxin ul').empty();
                    $('.slideTxtBox-02 .jinjie ul').empty();
                    $('.slideTxtBox-02-th .zuixin').empty();
                    $('.slideTxtBox-02-th .mengxin').empty();
                    $('.slideTxtBox-02-th .jinjie').empty();
                    $('.left-video-box ul').empty();
                    $(".right-video-box video").attr("src", '');

                    // 无视频时 兜底图片
                    if (language_index == "zh" || language_index == "zh_CN") {
                        $(".right-video-box .thumbnail-img img").attr("src", "//download4.qcplay.com/pic/pal/official/mobile/en/media/video_top_img.png");
                    } else if (language_index == "th") {
                        $(".right-video-box .thumbnail-img img").attr("src", "//download4.qcplay.com/qcgame-api/LFF2CwHRA9INfAhspg8TprwzmeCTM6NvlGFtrh9p.jpeg");
                    } else {
                        $(".right-video-box .thumbnail-img img").attr("src", "https://download4.qcplay.com/qcgame-api/tNht4H2ZAGiavaRKle5XIay4ffrb5RXYl8dR2CUc.jpeg");
                    }

                    // 【游戏攻略】最新
                    $.each(zuixin, function(index, values) {
                        var zuixinHtml = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.created_at}</p>
                            </a>
                        </li>`;
                        if (language_index == "th") {
                            $('.slideTxtBox-02-th .zuixin').append(zuixinHtml);
                        } else {
                            $('.new ul').append(zuixinHtml);
                        }
                    });

                    // 【游戏攻略】萌新
                    $.each(mengxin, function(index, values) {
                        var mengxinHtml = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.created_at}</p>
                            </a>
                        </li>`;
                        if (language_index == "th") {
                            $('.slideTxtBox-02-th .mengxin').append(mengxinHtml);
                        } else {
                            $('.mengxin ul').append(mengxinHtml);
                        }
                    });

                    // 【游戏攻略】进阶
                    $.each(jinjie, function(index, values) {
                        var jinjieHtml = `<li>
                            <a href="introduction-details-mobile.html?id=${values.id}">
                                <h2>${values.article_title}</h2>
                                <p>${values.created_at}</p>
                            </a>
                        </li>`;
                        if (language_index == "th") {
                            $('.slideTxtBox-02-th .jinjie').append(jinjieHtml);
                        } else {
                            $('.jinjie ul').append(jinjieHtml);
                        }
                    });

                    // 【仙剑音画】视频
                    if (video.length !== 0) {
                        $(".right-video-box .thumbnail-img img").attr("src", video[0].move_thumbnail);
                        $(".right-video-box video").attr("src", video[0].video_link);
                    }

                    $.each(video, function(index, values) {
                        var videoHtml = `<li>
                        <img src="${values.thumbnail}" data="${values.video_link}" >
                        </li>`;
                        $('.left-video-box ul').append(videoHtml);
                    });

                    $('.left-video-box ul').children(':eq(0)').addClass('on');
                    _this.indexMedia();

                    _this.Textlength(25, 20);
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            initialSlide: initialSlide,
            touchMoveStopPropagation: false,
            touchStartForcePreventDefault: true,
            on: {
                init: function() {
                    swiperAnimate(this);

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            mySwiper.slideTo(page, 1000, true);
                        });
                    };

                    function navLink() {
                        for (var i = 6; i >= 0; i--) {
                            Ani('.nav-link-0' + i + ' .link-a', i);
                        };
                    }
                    navLink();

                    var aniLink01 = Ani('.arrow-b', '1');
                    var aniLink02 = Ani('.arrow-b2', '2');
                    var aniLink04 = Ani('.arrow-b3', '3');
                },
                slideChangeTransitionEnd: function() {
                    $('.nav-link').removeClass('on')
                    $('.nav-link-0' + this.activeIndex + '').addClass('on');
                },
                transitionStart: function() {
                    swiperAnimate(this);
                },
            },
        });

        if (go_page !== undefined) {
            mySwiper.slideTo(go_page - 1, 1000, true);
        }

        // 游戏特色
        var charitySwiper = new Swiper('.swiper-container-feature', {
            loop: true,
            paginationClickable: true,
            pagination: {
                el: '.swiper-pagination4',
                clickable: true,
            },
            noSwiping: true,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 'auto',
            loopedSlides: '5',
            observer: true,
            observerParents: true,
            speed: 500,
            coverflowEffect: {
                rotate: 3, // 旋转的角度
                stretch: 40, // 拉伸   图片间左右的间距和密集度
                depth: 25, // 深度   切换图片间上下的间距和密集度
                modifier: 15, // 修正值 该值越大前面的效果越明显
                slideShadows: false // 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(this);
                swiper.stopAutoplay();
            },
        });
    },
    // 游戏咨询&游戏攻略信息切换
    jqslideTxtBox: function() {
        jQuery(".slideTxtBox").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".slideTxtBox-02").slide({ effect: "left", trigger: "click", easing: "swing" });
        jQuery(".slideTxtBox-02-th").slide({ effect: "left", trigger: "click", easing: "swing" });
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    analysisParams: function(url) {
        const params = {};
        const paramsString = url.split('?')[1];
        if (!paramsString) {
            return params;
        }
        const str = paramsString.split('&');
        for (let idx = 0; idx < str.length; idx++) {
            const values = str[idx].split('=');
            params[values[0]] = values[1];
        }
        return params;
    },
    // 游戏攻略接口
    newsIntrList: function() {
        const params = obj.analysisParams(window.location.href);
        var cate_id, page, current, index;
        cate_id = params.cate_id;
        page = params.page;
        current = window.location.href.split("?")[0];

        index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.news .tab-title .a-tab-' + cate_id + '').addClass('on').siblings('a').removeClass('on');

        type = language_index == "zh" || language_index == "zh_CN" ? 1 : language_index == "th" ? 3 : 2;

        $.ajax({
            url: "https://api.qingcigame.com/web/article",
            type: "GET",
            data: {
                game_id: 115,
                cate_id: cate_id, //最新-综合-活动
                page: page,
                type: type
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var current_page = json.data.articleList.current_page; // 当前页数
                    var last_page = json.data.articleList.last_page; // 总共页数
                    var prev_page_url = json.data.articleList.prev_page_url; // 前一页
                    var next_page_url = json.data.articleList.next_page_url; // 后一页
                    var _data = json.data.articleList.data;
                    if (_data.length == 0) {
                        $('.main').addClass('list-null');
                        // 先清空内容
                        $('.new-list ul').empty();

                    } else {
                        $('.main').removeClass('list-null');

                        // 先清空内容
                        $('.new-list ul').empty();
                        // 渲染列表
                        $.each(_data, function(index, values) {
                            var dtHtml = '<li>' +
                                '<a title="' + values.article_title + '" href="introduction-details.html?id=' + values.id + '">' +
                                '<p class="lside">' +
                                '<span class="time">' + values.created_at + '</span>' +
                                '<span class="title" style="display: block;">' + values.article_title + '</span>' +
                                '</p>' +
                                '</a>' +
                                '</li>';
                            $('.new-list ul').append(dtHtml);
                        });

                        obj.translateIntroList();

                        $('.new-list').addClass('new-list-show');
                        $('.current_page').html(current_page); // 当前页数
                        $('.last_page').html(last_page); // 总共页数
                        if (prev_page_url === null) { // 上一页
                            $('.front-link').hide(); // 没有第一页
                        } else {
                            $('.front-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + prev_page_url.split("?page=")[1])
                        }
                        if (next_page_url === null) { // 下一页
                            $('.after-link').hide(); // 没有最后一页
                        } else {
                            $('.after-link').attr('href', current + '?cate_id=' + cate_id + '&page=' + next_page_url.split("?page=")[1])
                        }
                    }
                } else {
                    $('.pager').css('opacity', '0');
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.news .tab-title').on('click', 'a', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });
    },
    // 游戏攻略详情
    intrInfo: function() {
        var id = obj.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        type = language_index == "zh" || language_index == "zh_CN" ? 1 : language_index == "th" ? 3 : 2;

        $.ajax({
            url: "https://api.qingcigame.com/web/article/" + id + "",
            data: {
                type: type
            },
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                $('.news-det .main').addClass('main-show');
                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.article_excerpt; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    $('.news .news-title h3, .current-title').html(newsTitle);
                    $('.news .origin').html(origin);
                    $('.news .created_at').html(created_at);
                    $('.details-info').append(detailsInfo);

                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');

                    $('title').html(newsTitle);
                    $('meta[name="keywords"]').attr('content', json.data.list.article_keywords);
                    $('meta[name="description"]').attr('content', json.data.list.article_excerpt);

                    // 图片点击预览功能
                    obj.indexBind();
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '='
        if (lastPage !== '') $('.prev-page').addClass('show').attr('href', href + lastPage.id).attr('title', lastPage.article_title);
        if (nextPage !== '') $('.next-page').addClass('show').attr('href', href + nextPage.id).attr('title', nextPage.article_title);
    },
    pageShow: function() {
        $('.page').addClass('pageShow');
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    },
    // 多语言
    language: function() {
        // console.log(navigator.language, navigator.userLanguage, language_index);
        let defaultLanguage = navigator.language || navigator.userLanguage;
        const that = this;
        jQuery(document).ready(function() {
            const language_cookie = $.cookie("language");
            // console.log(language_cookie, "language_cookie");

            if (!language_cookie) {
                if (
                    defaultLanguage == "zh" ||
                    defaultLanguage == "zh-CN" ||
                    defaultLanguage == "en-US" ||
                    defaultLanguage == "en" ||
                    defaultLanguage == "th"
                ) {
                    if (defaultLanguage == "zh") {
                        language_index = "zh";
                    } else if (defaultLanguage == "zh-CN") {
                        language_index = "zh_CN";
                    } else if (defaultLanguage == "th") {
                        language_index = "th";
                    } else {
                        language_index = "en_US";
                    }
                }

                $.cookie("language", language_index);
            } else {
                language_index = language_cookie;
            }

            if (language_index == "zh" || language_index == "zh_CN") {
                $(".zh").addClass("on");
                $(".leidian-btn").addClass("leidian-btn-zh").removeClass("leidian-btn-en");
                $(".landie-btn").addClass("landie-btn-zh").removeClass("landie-btn-en");
                $(".content-02 .slideTxtBox-02-th").fadeOut();
                $(".content-02 .slideTxtBox-02").fadeIn();
                $(".content-04 .media-nav-box").addClass("media-zh-nav");
                $(".footer-content").removeClass("en-footer");
            } else if (language_index == "th") {
                $(".th").addClass("on"); //多语言切换按钮
                $(".nav-box").addClass("th-nav"); //右侧导航栏
                $(".leidian-btn").addClass("leidian-btn-th").removeClass("leidian-btn-en"); //雷电模拟器链接
                $(".landie-btn").addClass("landie-btn-th").removeClass("landie-btn-en"); //蓝叠模拟器链接
                $(".content-02 .slideTxtBox-02").fadeOut(); //隐藏游戏攻略中英版
                $(".content-02 .slideTxtBox-02-th").fadeIn(); //显示游戏攻略泰语版
                $(".content-04 .media-nav-box").addClass("media-th-nav"); //仙剑音画切换导航栏
                $(".footer-content").removeClass("en-footer").addClass("th-footer"); //泰语footer
            } else {
                $(".en").addClass("on");
                $(".nav-box").addClass("en-nav");
                $(".leidian-btn").addClass("leidian-btn-en").removeClass("leidian-btn-zh");
                $(".landie-btn").addClass("landie-btn-en").removeClass("landie-btn-zh");
                $(".content-02 .slideTxtBox-02-th").fadeOut();
                $(".content-02 .slideTxtBox-02").fadeIn();
                $(".slideTxtBox-02 .p1 .new").addClass("en-new");
                $(".slideTxtBox-02 .p2 .mengxin").addClass("en-mengxin");
                $(".slideTxtBox-02 .p3 .jinjie").addClass("en-jinjie");
            }
            that.loadProperties(language_index);
        });
        // 切换语言
        $(".language-change-box .change-btn").on("click", function() {
            let languageType = $(this).data("id");
            if ($(this).hasClass("on")) {
                return;
            }
            $(".language-change-box .change-btn").removeClass("on");
            // console.log(languageType, "languageType");
            language_index = languageType || DEFAULT_LANGUAGE;
            that.loadProperties(language_index);
            $.cookie("language", language_index);
            $(this).addClass("on");
            $(`.${language_index}`).addClass("on");

            if (language_index == "zh" || language_index == "zh_CN") {
                $(".nav-box").removeClass("en-nav").removeClass("th-nav");
                $(".leidian-btn").addClass("leidian-btn-zh").removeClass("leidian-btn-en");
                $(".landie-btn").addClass("landie-btn-zh").removeClass("landie-btn-en");
                $(".content-02 .slideTxtBox-02-th").fadeOut();
                $(".content-02 .slideTxtBox-02").fadeIn();
                $(".slideTxtBox-02 .p1 .new").removeClass("en-new");
                $(".slideTxtBox-02 .p2 .mengxin").removeClass("en-mengxin");
                $(".slideTxtBox-02 .p3 .jinjie").removeClass("en-jinjie");
                $(".content-04 .media-nav-box").addClass("media-zh-nav").removeClass("media-th-nav").removeClass("media-en-nav");
                $(".footer-content").removeClass("en-footer").removeClass("th-footer");
            } else if (language_index == "th") {
                $(".nav-box").addClass("th-nav").removeClass("en-nav");
                $(".leidian-btn").addClass("leidian-btn-th").removeClass("leidian-btn-en");
                $(".landie-btn").addClass("landie-btn-th").removeClass("landie-btn-en");
                $(".content-02 .slideTxtBox-02").fadeOut();
                $(".content-02 .slideTxtBox-02-th").fadeIn();
                $(".content-04 .media-nav-box").addClass("media-th-nav").removeClass("media-zh-nav").removeClass("media-en-nav");
                $(".footer-content").removeClass("en-footer");
                $(".footer-content").addClass("th-footer");
            } else {
                $(".nav-box").addClass("en-nav").removeClass("th-nav");
                $(".leidian-btn").addClass("leidian-btn-en").removeClass("leidian-btn-zh");
                $(".landie-btn").addClass("landie-btn-en").removeClass("landie-btn-zh");
                $(".content-02 .slideTxtBox-02-th").fadeOut();
                $(".content-02 .slideTxtBox-02").fadeIn();
                $(".slideTxtBox-02 .p1 .new").addClass("en-new");
                $(".slideTxtBox-02 .p2 .mengxin").addClass("en-mengxin");
                $(".slideTxtBox-02 .p3 .jinjie").addClass("en-jinjie");
                $(".content-04 .media-nav-box").addClass("media-en-nav").removeClass("media-zh-nav").removeClass("media-th-nav");
                $(".footer-content").removeClass("th-footer").addClass("en-footer");
            }

            var indexUrl = window.location.href.includes("index");
            if (indexUrl) {
                obj.indexAjax();
                obj.indexMedia();
            } else {
                obj.newsIntrList();
            }

            // 无视频播放时兜底
            $('.thumbnail-img').fadeIn();
            $('.right-video-box video').show();
            $('.video-btn-box').fadeIn();
        });
    },
    // 调用多语言
    loadProperties: function(type) {
        const that = this;
        jQuery.i18n.properties({
            name: "strings", // 资源文件名称
            path: "/official/language/", // 资源文件所在目录路径
            mode: "map", // 模式：变量或 Map
            language: type, // 对应的语言
            cache: false,
            encoding: "UTF-8",
            callback: function() {
                // 回调方法
                that.translatePublic();
                that.translateContent01();
                that.translateContent02();
                that.translateContent03();
                that.translateContent04();
                that.translateIntroList();
                that.translateNewsDetail();
                that.translateInfo();
            },
        });
    },
    // 网页杂项
    translatePublic: function() {
        this.replaceBgimg(".preloading .loading-logo", $.i18n.prop("loading-logo"));
        $(".orientation-portrait img").attr("src", $.i18n.prop("fanzhuan"));
        $(".privacy_policy").html($.i18n.prop("yszc"));
        $(".service_agreement").html($.i18n.prop("yhxy"));
        $(".privacy_policy").attr("href", $.i18n.prop("yszcUrl"));
        $(".service_agreement").attr("href", $.i18n.prop("yhxyUrl"));
    },
    // 修改网站信息
    translateInfo: function() {
        $(".page_title").html($.i18n.prop("title"));
        $(".page_keywords").attr("content", $.i18n.prop("keywords"));
        $(".page_description").attr("content", $.i18n.prop("description"));
        $(".ogp-share-img").attr("content", $.i18n.prop("ogp-share-img"));
    },
    // 修改第一屏
    translateContent01: function() {
        $(".nav-link-00 span").html($.i18n.prop("nav-01"));
        $(".nav-link-01 span").html($.i18n.prop("nav-02"));
        $(".nav-link-02 span").html($.i18n.prop("nav-03"));
        $(".nav-link-03 span").html($.i18n.prop("nav-04"));
        $(".logo img").attr("src", $.i18n.prop("logo-img"));
        this.replaceBgimg("top-up-btn", $.i18n.prop("top-up-btn"));
        this.replaceBgimg("app-btn", $.i18n.prop("apple-btn"));
        this.replaceBgimg("and-btn", $.i18n.prop("and-btn"));
        this.replaceBgimg("leidian-btn", $.i18n.prop("leidian-btn"));
        this.replaceBgimg("landie-btn", $.i18n.prop("landie-btn"));
        this.replaceBgimg("arrow-bottom i", $.i18n.prop("arrow-btn"));
        $(".facebook-btn").attr("href", $.i18n.prop("facebook-btn"));
        $(".fb-group-btn").attr("href", $.i18n.prop("fb-group-btn"));
    },
    // 修改第二屏
    translateContent02: function() {
        this.replaceBgimg("content-02 .title", $.i18n.prop("title2"));
        this.replaceBgimg(".intro .p1 .page-slide", $.i18n.prop("guide-01"));
        this.replaceBgimg(".intro .p2 .page-slide", $.i18n.prop("guide-02"));
        this.replaceBgimg(".intro .p3 .page-slide", $.i18n.prop("guide-03"));
        $(".more-btn a").html($.i18n.prop("view-more"));
    },
    // 修改第三屏
    translateContent03: function() {
        this.replaceBgimg("content-03 .title", $.i18n.prop("title3"));
        $(".card-1 img").attr("src", $.i18n.prop("card-1"));
        $(".card-2 img").attr("src", $.i18n.prop("card-2"));
        $(".card-3 img").attr("src", $.i18n.prop("card-3"));
        $(".card-4 img").attr("src", $.i18n.prop("card-4"));
        $(".card-5 img").attr("src", $.i18n.prop("card-5"));
        $(".card-6 img").attr("src", $.i18n.prop("card-6"));
    },
    // 修改第四屏
    translateContent04: function() {
        this.replaceBgimg("content-04 .title", $.i18n.prop("title4"));
        this.replaceBgimg("drag-bar", $.i18n.prop("drag-bar"));
        for (let i = 1; i <= 10; i++) {
            $(`.wallpaper-${i} img`).attr("src", $.i18n.prop(`wallpaper-${i}`));
        }
    },
    // 翻译攻略列表页
    translateIntroList: function() {
        $(".list_nav").html($.i18n.prop("current"));
        $(".list_home").html($.i18n.prop("home"));
        $(".list_game_news").html($.i18n.prop("game_news"));
        $(".list_game_details").html($.i18n.prop("game_news_detail"));

        $(".news-title").html($.i18n.prop("GAME_NEWS"));
        $(".a-tab-112").html($.i18n.prop("latest"));
        $(".a-tab-114").html($.i18n.prop("mengxin"));
        $(".a-tab-115").html($.i18n.prop("jinjie"));
        this.replaceBgimg("news .top-tab .return-btn", $.i18n.prop("return-btn"));
    },
    // 翻译攻略详情页
    translateNewsDetail: function() {
        this.replaceBgimg("prev-page", $.i18n.prop("previous"));
        this.replaceBgimg("next-page", $.i18n.prop("next"));
    },
    // 切换语言替换图片
    replaceBgimg: function(className, url) {
        $(`.${className}`).css({
            background: `url(${url}) no-repeat`,
        });
    },
}